import {FC, useCallback} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router";
import {BASE_URL, GAME_ZONE_URL} from "modules/constants";
import {getIsOpenDontLoseTeamModal} from "modules/selectors";
import {closeDontLoseTeamModal} from "modules/actions";
import {PrimaryDarkExternalLink, SecondaryExternalLink} from "components/Common";
import {ModalText, ModalTitle, ModalIcon, ButtonsBox} from "components/Modals/common";
import {BaseModal} from "components/Modals/BaseModal";
import icon from "assets/images/icons/modalWarningIcon.svg";

const getUri = (page: string, redirectUri: string) =>
	redirectUri ? `${GAME_ZONE_URL}${page}?redirectUri=${BASE_URL}${redirectUri}` : `login`;

export const DontLoseTeamModal: FC = () => {
	const {t} = useTranslation();
	const location = useLocation();
	const dispatch = useDispatch();
	const isOpen = useSelector(getIsOpenDontLoseTeamModal);

	const closeHandler = useCallback(() => {
		dispatch(closeDontLoseTeamModal());
	}, [dispatch]);

	if (!isOpen) {
		return null;
	}

	return (
		<BaseModal handleClose={closeHandler}>
			<ModalIcon className="small" src={icon} alt="Warning" />
			<ModalTitle>{t("page.picks.dont_lose_team_modal.title")}</ModalTitle>
			<ModalText>{t("page.picks.dont_lose_team_modal.desc")}</ModalText>
			<ButtonsBox>
				<SecondaryExternalLink
					target="_self"
					href={getUri("login", `${location.pathname}?save=true`)}>
					{t("page.picks.dont_lose_team_modal.sign_in")}
				</SecondaryExternalLink>

				<PrimaryDarkExternalLink
					target="_self"
					href={getUri("registration", `${location.pathname}?save=true`)}>
					{t("page.picks.dont_lose_team_modal.sign_up")}
				</PrimaryDarkExternalLink>
			</ButtonsBox>
		</BaseModal>
	);
};
